// @flow
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import * as React from 'react'

type Props = {
  ...React.ElementConfig<'img'>,
  placeholder: React.Node,
}

const Gif = ({ placeholder, ...props }: Props) => {
  const [loaded, setLoaded] = React.useState(false)
  const onLoad = React.useCallback(() => setLoaded(true), [setLoaded])

  return (
    <Root>
      <StyledImg {...props} onLoad={onLoad} isLoading={!loaded} />
      {!loaded && placeholder}
    </Root>
  )
}

export default Gif

const Root: React.ComponentType<React.ElementConfig<'div'>> = styled.div`
  display: inline-block;
`

const loadingCss = css`
  position: absolute;
  visibility: hidden;
`

const StyledImg: React.ComponentType<{
  ...React.ElementConfig<'img'>,
  isLoading: boolean,
}> = styled.img`
  ${(p) => p.isLoading && loadingCss}
`
